"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PAGE_SIZE = exports.REGEXP = exports.PREFIX_SCENARIO_MAPPING = exports.PATH_CATEGORY_MAPPING = exports.ORDER_FIELD_KEYWORDS = exports.FIELD_PREFIXES_SPECIAL_KEYWORD = exports.FIELD_PREFIXES_NEED_BACKSLASH = exports.FIELD_PREFIXES_NEED_TREATMENT = exports.SMART_ALBUM_TYPES = exports.STATE_FIELDS = void 0;
exports.STATE_FIELDS = ['tenant', 'context', 'user', 'path', 'search', 'filter', 'order', 'offset', 'size'];
exports.SMART_ALBUM_TYPES = ['image', 'video', 'audio', 'document', 'presentation', 'other'];
exports.FIELD_PREFIXES_NEED_TREATMENT = ['approval', 'tagLiteral', 'keywordLiteral', 'meta_multichoice', 'meta_choice', 'meta_text', 'watermark'];
exports.FIELD_PREFIXES_NEED_BACKSLASH = ['meta_multichoice', 'meta_choice', 'meta_text'];
exports.FIELD_PREFIXES_SPECIAL_KEYWORD = ['meta_text'];
exports.ORDER_FIELD_KEYWORDS = new Map(Object.entries({
    'type': 'scheme',
    'name': 'name',
    'owner': 'owner_result',
    'author': 'author_result',
    'size': 'size',
    'time': 'time',
    'firstName': 'firstName',
    'lastName': 'lastName',
    'role': 'role',
    'deleter': 'deleted_by.keyword',
    'deleteTime': 'deleted',
    'modifiedBy': 'last_modified_by.keyword',
    'createDate': 'create_date.keyword',
    'uploadDate': 'created',
    'modifiedDate': 'last_modified',
    'status': 'approval.keyword',
    'DPI': 'resolution',
    'duration': 'duration_facet',
    'page': 'page'
}));
exports.PATH_CATEGORY_MAPPING = new Map(Object.entries({
    'allfiles': 'smartalbum',
    'smartalbum': 'smartalbum',
    'library': 'library',
    'folder': 'folder',
    'album': 'album'
}));
exports.PREFIX_SCENARIO_MAPPING = new Map(Object.entries({
    'v': 'portal',
    'w': 'workspace',
    'g': 'styleguide'
}));
exports.REGEXP = {
    smartType: /\/smartalbum\/(.*)/i,
    collectionId: /\/myassetrequest\/(.*)/i,
    urlPath: /\.\w+(\/.*)\?/i,
    portalPrefix: /\/[guvwp]\/[\w-]*/,
    pathWithoutPrefix: /\/[guvwp]\/[\w-]*(\/.*)/i,
    sharePath: /\/s\/(\w+)/i,
    quotedValue: /(\"\w+\")+/i,
    filterSeparator: /^\\\!|\||\+|\.{2}(?=\d)/i,
    filterNotAction: /^\\\!/i
};
exports.DEFAULT_PAGE_SIZE = 100;
